import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { goToRecipes } from '@/utils/Common/Redirects';

import Button from '@/components/atoms/Button';
import ALink from '@/components/atoms/ALink';

const ButtonActionsBox = ({
  isRegistered,
  isProductReview,
  removeReview,
  readReview,
  simpleView,
  writeReview,
  removeEntry,
  editEntry,
  alreadyReviewed,
  fakeProduct,
  isReturn,
  printLabelBtn,
  printFormBtn,
  t,
  handleHowItWorksBtn,
  isReviewable,
  isOrderFlow,
  hasRecipes,
  automaticProductRegistration,
}) => {
  const alreadyReviewedClass = alreadyReviewed ? 'action-done' : '';

  if (isProductReview) {
    return (
      <>
        <ALink
          text={t('account:account.product.order.box.delete.review.label')}
          onClick={removeReview}
        />
        &nbsp;
        <Button
          onClick={readReview}
          text={t('account:account.product.order.box.read.review.label')}
          modifiers={['stroked']}
        />
      </>
    );
  }
  if (isRegistered) {
    return (
      <>
        <div className='dln-orderRev__wrap dln-orderRev__wrap--links'>
          <ALink text={t('text.delete')} onClick={removeEntry} />
          &nbsp;
          <ALink
            text={t(
              automaticProductRegistration ? 'text.visualize' : 'text.edit',
            )}
            onClick={editEntry}
          />
        </div>
        <div className='dln-orderRev__wrap dln-orderRev__wrap--links'>
          {hasRecipes && !fakeProduct && (
            <>
              <Button
                modifiers={['stroked']}
                text={t('account:account.product.recipe.suggestions')}
                onClick={goToRecipes}
              />
              &nbsp;
            </>
          )}
          {!fakeProduct && DLG.config.selectedReviewsSource === 'OOTB' && (
            <Button
              modifiers={['stroked', 'action-button', alreadyReviewedClass]}
              glyph={alreadyReviewed ? 'H' : ''}
              text={t(
                `account:account.product.order.box.${
                  alreadyReviewed ? 'already.' : ''
                }write.review.label`,
              )}
              onClick={writeReview}
            />
          )}
        </div>
      </>
    );
  }
  if (
    !fakeProduct &&
    DLG.config.isLogged &&
    !simpleView &&
    !isReturn &&
    _isEmpty(printFormBtn) &&
    _isEmpty(printLabelBtn) &&
    ((isOrderFlow && isReviewable) || (!isOrderFlow && isReviewable == null))
  ) {
    return (
      <>
        {DLG.config.selectedReviewsSource === 'OOTB' && (
          <Button
            modifiers={['stroked', 'action-button', alreadyReviewedClass]}
            glyph={alreadyReviewed ? 'H' : ''}
            text={t(
              `account:account.product.order.box.${
                alreadyReviewed ? 'already.' : ''
              }write.review.label`,
            )}
            onClick={writeReview}
          />
        )}
      </>
    );
  }
  if (!isReturn && (!_isEmpty(printFormBtn) || !_isEmpty(printLabelBtn))) {
    return (
      <>
        {printFormBtn && (
          <a href={printFormBtn} download>
            <Button
              modifiers={['stroked']}
              onClick={() => {}}
              text={t('account:account.order.return.print.form')}
            />
          </a>
        )}
        {printLabelBtn && (
          <a href={printLabelBtn} download>
            <Button
              modifiers={['stroked']}
              text={t('account:account.order.return.print.label')}
              onClick={() => {}}
            />
          </a>
        )}
        <button
          type='button'
          className='dln-orderRev__howItWorks'
          onClick={handleHowItWorksBtn}
        >
          {t('account:account.order.return.how.work.lbl')}
        </button>
      </>
    );
  }
  return null;
};

ButtonActionsBox.propTypes = {
  isRegistered: PropTypes.bool.isRequired,
  isProductReview: PropTypes.bool.isRequired,
  removeReview: PropTypes.func,
  readReview: PropTypes.func,
  simpleView: PropTypes.bool.isRequired,
  writeReview: PropTypes.func,
  removeEntry: PropTypes.func,
  editEntry: PropTypes.func,
  alreadyReviewed: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  fakeProduct: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  t: PropTypes.func.isRequired,
  isReturn: PropTypes.bool,
  printLabelBtn: PropTypes.string,
  printFormBtn: PropTypes.string,
  handleHowItWorksBtn: PropTypes.func,
  isReviewable: PropTypes.bool,
  isOrderFlow: PropTypes.bool,
  hasRecipes: PropTypes.bool,
  automaticProductRegistration: PropTypes.bool.isRequired,
};

ButtonActionsBox.defaultProps = {
  removeReview: null,
  readReview: null,
  writeReview: null,
  removeEntry: null,
  editEntry: null,
  alreadyReviewed: false,
  fakeProduct: false,
  isReturn: false,
  printLabelBtn: null,
  printFormBtn: null,
  handleHowItWorksBtn: () => {},
  isReviewable: false,
  isOrderFlow: false,
  hasRecipes: false,
};

export default ButtonActionsBox;
